import { numberParser } from '../inboundParsers';
export const REBUY_SUCCESS_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'numRebuyChips', parser: numberParser },
        { name: 'rebuyDelaySecondsLeft', parser: numberParser }
    ]
};
